import { render, staticRenderFns } from "./SlidePage4.vue?vue&type=template&id=2563b4f2&"
import script from "./SlidePage4.vue?vue&type=script&lang=ts&"
export * from "./SlidePage4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports